import React, {useState, useEffect, CSSProperties, ChangeEvent} from 'react';
import { IQuestionEditorState, IAnswerEditor } from 'app_components/modules/academicComponentEditor/containers/academicComponentEditorFunctions';
import TinyEditorComponent from 'app_components/commons/tinyEditor';
import shortId from 'shortid';
import { copyObjectEditor, getTextTinyFillInSpaces, getQuestionFromChangeTinyFillInSpaces } from 'app_utils/functions/editorFunctions';
// import RelateItemsEditorComponent from 'app_components/commons/relateItemsEditor';
import { Form, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IConfigQuestion, IQuestionEventType, IQuestionTag2, ITermsAndConditions } from 'app_types/editor/questionTypes';
import QuestionsService from 'app_services/editor/questions/questionsService';
import { useQuery } from 'app_hooks/useQuery';
// import TagsSelect2Component from '../../tagsSelect2';
import { IQuestionMetadata } from 'app_types/editor/questionTypes';
// import PreviewQuestionComponent from '../../previewQuestion';
// import EditorPanelExerciseMetadata from './editorPanelMetadataFields';
import HeaderEditorPanelExercise from './headerEditorPanelExercise/headerEditorPanelExercise';
import CheckBoxComponent from 'app_components/commons/checkBox/containers/checkBoxComponent';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import NewQuestionButton from '../../newQuestionButton/newQuestionButton';
import OutlineContainerDrag from '../../outlineContainerDrag/outlineContainerDrag';
import Swal from 'sweetalert2';
import { useColors } from 'app_hooks/useColors';
// import ConfigQuestionPanel from '../../configQuestionPanel/configQuestionPanel';
import { GrFormAdd } from 'react-icons/gr';
import InputFieldEditorComponent from '../../inputFieldEditorComponent/inputFieldEditorComponent';
import { MdClose } from 'react-icons/md';
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';
import InputComponent from 'app_components/commons/Input/InputComponent';


import '../editorPanelExerciseEditor.scss'

interface IEditorPanelExerciseEditorLayoutProps {
    question: IQuestionEditorState
    metadata?: IQuestionMetadata[]
    loading?: boolean
    editState: boolean
    tags?: IQuestionTag2[]
    hideDeleteButton?: boolean
    hideAddButton?: boolean
    hideFinishButton?: boolean
    hideViewButton?: boolean
    hideEditButton?: boolean
    hideTitle?: boolean
    showDeleteButton?: boolean
    children?: any
    className?: string
    style?: CSSProperties
    defaultCorrect?: boolean
    hideCorrectCheck?: boolean
    hideValueField?: boolean
    showRequiredCheck?: boolean
    hideFeedbackField?: boolean
    eventTypes?: IQuestionEventType[]
    termsAndConditions?: ITermsAndConditions[]
    showValidationSettings?: boolean
    isCharacterizationSurvey?: boolean
    onClickSave?: (resp: IQuestionEditorState) => void
    onClickDelete?: (question?: IQuestionEditorState) => void
    onQuestionSaved?: (status?: boolean) => void
    onQuestionDeleted?: (status?: boolean) => void
    onChangeQuestion?: (question?: IQuestionEditorState)=>void
    onClickEdit?: (question?: IQuestionEditorState)=>void
    onClickFinish?: ()=>void
    onClickView?: (question: IQuestionEditorState)=>void
}


const EditorPanelExerciseEditorLayout: React.FC<IEditorPanelExerciseEditorLayoutProps> = (props) => {

    const [question, updateQuestion] = useState<IQuestionEditorState | undefined>(undefined)
    const [reload, updateReload] = useState(false)
    const [invalidTags, updateInvalidTags] = useState(false)
    const [resetAnswers, updateResetAnswers] = useState(false)
    const [loading, updateLoading] = useState(false)
    const [preview, updatePreview] = useState(false)
    const [openNewAnswerFill, updateOpenNewAnswerFill] = useState(false)
    const {t} = useTranslation()
    const [colors] = useColors()
    const {query} = useQuery()

    // Servicios
    const questionService = new QuestionsService()

    // Actualizar la pregunta
    useEffect(() => {
        // console.log('Actualizo la question');
        if(props.question){
            const aux = JSON.parse(JSON.stringify(props.question))
            updateQuestion(aux)
            updateReload(true)
            setTimeout(() => {
                updateReload(false)
            }, 50)
        }
    },[props.question])

    useEffect(() => {
        if(!props.editState){
            if(props.question){
                const aux = JSON.parse(JSON.stringify(props.question))
                updateQuestion(aux)
                updateReload(true)
                setTimeout(() => {
                    updateReload(false)
                }, 50)
            }
        }
    }, [props.editState])

    /**
     * @INFO Referencia del cambio en el tiny de enunciado pregunta
     * @param content
     * @param editor
     */
    const handleChangeContentQuestion = (content: string) => {
        const aux: IQuestionEditorState = copyObjectEditor(question)
        aux.question.content = content
        updateQuestion(copyObjectEditor(aux))
        sendOnChangeQuestion(aux)
    }

    const handleChangeShowAsSelect = () => {
      const aux: IQuestionEditorState = copyObjectEditor(question)
      if (aux?.question?.config?.show_as_select) {
        aux.question.config.show_as_select = false
      } else {
        aux.question.config.show_as_select = true
      }
      updateQuestion(copyObjectEditor(aux))
      sendOnChangeQuestion(aux)
    }

    /**
     * @INFO Cambio de la data en un editor
     * @param type
     * @param idAnswer
     * @param content
     * @param editor
     */
    const handleEditorChange = ( type: 'content' | 'feedback', idAnswer: string, content: any) => {
        const aux: IQuestionEditorState = copyObjectEditor(question)
        const idxAnswer = aux.question.answers.findIndex(item => item._id === idAnswer )
        if(idxAnswer < 0) return
        if(type === 'content'){
            aux.question.answers[idxAnswer].content = content
            updateQuestion(copyObjectEditor(aux))
        }else{
            aux.question.answers[idxAnswer].feedback = content
            updateQuestion(copyObjectEditor(aux))
        }
        sendOnChangeQuestion(aux)
    }

    /**
     * @INFO Actualizar el estado de correcto según el tipo de pregunta
     * @param idAnswer
     */
    const handleClickCorrect = (idAnswer: string) => {
        if(!question) return
        const aux = {...question}
        const answers = [...question.question.answers]
        if(question.question.question_category.name === 'multiple-choice-unique-answer'){
            // Pasar todas las respuestas a false
            answers.forEach((item, idx) => {
                answers[idx].is_correct = false
            })
            // Colocar en true la seleccionada
            const idxAnswer = answers.findIndex(item => item._id === idAnswer)
            if(idxAnswer >= 0){
                if(answers[idxAnswer].is_correct){
                    answers[idxAnswer].is_correct = false
                }else{
                    answers[idxAnswer].is_correct = true
                }
            }
            // Actualizar las respuestas
            aux.question.answers = [...answers]
            updateQuestion({...aux})
        }else if(question.question.question_category.name === 'multiple-choice-multiple-answer'){
            // Colocar en true la seleccionada
            const idxAnswer = answers.findIndex(item => item._id === idAnswer)
            if(idxAnswer >= 0){
                if(answers[idxAnswer].is_correct){
                    answers[idxAnswer].is_correct = false
                }else{
                    answers[idxAnswer].is_correct = true
                }
            }
            // Actualizar las respuestas
            aux.question.answers = [...answers]
            updateQuestion({...aux})
        }
        sendOnChangeQuestion(aux)
    }

    /**
     * @INFO Cambiar el valor de is_required
     */
    const handleClickRequired = (idAnswer: string) => {
      if(!question) return
      const aux = {...question}
      const answers = [...question.question.answers]
      // @INFO Encontrar la respuesta
      const idxAnswer = answers.findIndex(item => item._id === idAnswer)
      if(idxAnswer >= 0){
        if(answers[idxAnswer].config !== undefined && answers[idxAnswer].config?.is_required !== undefined){
          if(answers[idxAnswer].config?.is_required){
            // @ts-ignore
              answers[idxAnswer].config.is_required = false
          }else{
            // @ts-ignore
              answers[idxAnswer].config.is_required = true
          }
        }else{
          answers[idxAnswer].config = {
            ...(answers[idxAnswer].config ? answers[idxAnswer].config : {}),
            is_required: true
          }
        }
        // Actualizar las respuestas
        aux.question.answers = [...answers]
        updateQuestion({...aux})
      }
      sendOnChangeQuestion(aux)
    }

    /**
     * @INFO Cambio de configuraciones de recurso validación
     * @param e
     * @param idAnswer
     * @param type
     * @returns
     */
    const handleChangeValidationSetting = (e: any, idAnswer: string, type: 'event_type' | 'terms_and_conditions') => {
      if(!question) return
      const aux = {...question}
      const answers = [...question.question.answers]
      // @INFO Encontrar la respuesta
      const idxAnswer = answers.findIndex(item => item._id === idAnswer)
      if(idxAnswer >= 0){
        if(type === 'event_type'){
          // @INFO encontrar el event type y reemplazar el content con el template
          const event = props.eventTypes?.find((item) => item._id === e.target.value)
          if(event){
            answers[idxAnswer].content = event.template
            updateResetAnswers(true)
            setTimeout(() => {
              updateResetAnswers(false)
            }, 60)
          }
          // @INFO Si el event type no tiene términos elimino el campo
          if(!event?.config?.has_terms_and_conditions){
            delete answers[idxAnswer].config?.terms_and_conditions
          }
        }
        if(answers[idxAnswer].config){
          // @ts-ignore
          answers[idxAnswer].config[type] = e.target.value
        }else{
          answers[idxAnswer].config = {
            [type]: e.target.value
          }
        }
        // Actualizar las respuestas
        aux.question.answers = [...answers]
        updateQuestion({...aux})
      }
      sendOnChangeQuestion(aux)
    }

    /**
     * @INFO Añadir una nueva respuesta
     */
    const handleAddNewAnswer = () => {
        if(!question) return
        const newAnswer: IAnswerEditor = {
            _id: shortId.generate(),
            content: '',
            is_correct: props.defaultCorrect ? true : false,
            unique: '',
            value: props.defaultCorrect ? 5 : 0,
            feedback: '',
            config: {
              is_required: false
            }

        }
        const aux = {...question}
        aux.question.answers = [...aux.question.answers, newAnswer]
        updateQuestion({...aux})
        sendOnChangeQuestion(aux)
    }

    const handleChangeCategory = (value: string) => {
      const aux = {...question}
      if (aux) {
        if (aux?.question?.config) {
          aux.question.config.category = value
        }
        updateQuestion({...aux})
      }
    }

    /**
     * @INFO Eliminar respuesta
     * @param idxAnswer
     */
    const handleClickDeleteAnswer = (idxAnswer: number) => {
        const aux: IQuestionEditorState = JSON.parse(JSON.stringify(question))
        aux.question.answers.splice(idxAnswer, 1)
        updateQuestion(JSON.parse(JSON.stringify(aux)))
        sendOnChangeQuestion(aux)
    }

    /**
     * @INFO Actualizar valor de pregunta o respuesta
     * @param idxAnswer
     */
    const handleChangeValue = (e: any, idxAnswer?: number) => {
        const aux = {...question}
        if(idxAnswer !== undefined){
          // @ts-ignore
            aux.question.answers[idxAnswer].value = (e.target.value)
        }else{
          // @ts-ignore
            aux.question.value = (e.target.value)
        }
        // Actualizar estado
        updateQuestion({...(aux as IQuestionEditorState)})
        sendOnChangeQuestion(aux as IQuestionEditorState)
    }

    /**
     * @INFO Referencia para guardar una pregunta
     */
    const handleSaveQuestion = async () => {
        if(!question) return
        if(props.onClickSave){
            props.onClickSave(question as IQuestionEditorState)
        }else{
            // Si no hay handle externo para guardar la guardo desde aca
            updateLoading(true)
            const questionSend = {
                ...question.question
            }
            const response = await questionService.updateQuestion(
                questionSend._id,
                questionSend.question_category.name,
                questionSend
            )
            // Reviso el estado y lamo el callback si existe
            if(response && response.code === 200){
                if(props.onQuestionSaved){
                    props.onQuestionSaved(true)
                }
            }else{
                if(props.onQuestionSaved){
                    props.onQuestionSaved(false)
                }
            }
            updateLoading(false)
        }
    }

    /**
     * TODO Falta el endpoint para borrar una pregunta
     * @INFO Referencia para eliminar pregunta
     */
    const handleDeleteQuestion = () => {
        if(!question) return
        Swal.fire({
          title: t('editor.resources.exercise.delete_question.title'),
          text: t('editor.resources.exercise.delete_question.text'),
          showCancelButton: true,
          confirmButtonText: t('editor.resources.exercise.delete_question.delete'),
          cancelButtonText: t('editor.resources.exercise.delete_question.cancel'),
          confirmButtonColor: colors.primary,
          icon: 'warning',
        }).then((data) => {
            if(data.isConfirmed){
              if(props.onClickDelete){
                props.onClickDelete(copyObjectEditor(props.question))
              }else{
                  // Si no hay handle externo para borrar la borro desde aca
              }
            }
        }).catch(err => {})
    }

    /**
     * @INFO Enviar callback de on change
     * @param data
     */
    const sendOnChangeQuestion = (data?: IQuestionEditorState) => {
        if(props.onChangeQuestion){
            props.onChangeQuestion(data ? copyObjectEditor(data) : undefined)
        }
    }

    /**
     * @INFO Actualizar configuración de pregunta
     * @param data
     */
    const handleChangeConfig = (data: IConfigQuestion) => {
      const aux = {...question}
      if(!aux?.question) return
      aux.question.config = {...data}
      updateQuestion({...aux as IQuestionEditorState})
      sendOnChangeQuestion(aux as IQuestionEditorState)
    }

    /**
     * @INFO Reordenar las respuestas después de hacer drag and drop
     * @param result
     */
    const handleReorderAnswers = (result: any) => {
      if(!result.destination) return
      const startIndex = result.source.index
      const endIndex = result.destination.index
      const aux = {...question}
      if(aux.question?.answers){
        const [removed] = aux.question.answers.splice(startIndex, 1)
        aux.question.answers.splice(endIndex, 0, removed)
        updateQuestion({...aux as IQuestionEditorState})
        updateResetAnswers(true)
        setTimeout(() => {
          updateResetAnswers(false)
        }, 60)
      }
    }

    /**
     * @INFO Click en editar la pregunta desde el header
     */
    const handleClickEditQuestion = () => {
      if(props.onClickEdit){
        props.onClickEdit({...props.question})
      }
    }

    /**
     * @INFO Click en mirar pregunta
     */
    const handleClickViewQuestion = () => {
      if(props.onClickView && question){
        props.onClickView({...question})
      }
    }

    /**
     * @INFO Verificar si se debe mostrar los términos y condiciones
     */
    const handleShowTerms = (idEvent?: string) => {
      if(!idEvent) return false
      const event = props.eventTypes?.find((item) => item._id === idEvent)
      if(event && event.config?.has_terms_and_conditions){
        return true
      }
      return false
    }

    /**
     * @INFO Cambia el rango de la pregunta
     * @param e
     */
    const handleChangeRange = (e: ChangeEvent<HTMLInputElement>) => {
      const aux = {...question}
      if(!aux?.question) return
      aux.question.config.range = Number(e.target.value)
      updateQuestion({...aux as IQuestionEditorState})
      sendOnChangeQuestion(aux as IQuestionEditorState)
    }

    return (
        question && !reload ?
            <div
              className={`editor_panel_exercise_editor-component ${props.className ? props.className : ''}`}
              style={props.style}
            >
                {loading ? <div className='loading-page' >
                    <Spinner animation="border" className='icon-loading' />
                </div>: null}
                {/* ======= Header ========= */}
                <HeaderEditorPanelExercise
                  title={question?.question?.question_category?.name === 'container' ? "Sección" : question.question.question_category.description}
                  editState={props.editState}
                  hideDeleteButton={props.hideDeleteButton}
                  hideAddButton={props.hideAddButton}
                  hideFinishButton={props.hideFinishButton}
                  hideTitle={props.hideTitle}
                  hideEditButton={props.hideEditButton}
                  // onClickAdd={handleSaveQuestion}
                  hideViewButton={props.hideViewButton}
                  showDeleteButton={props.showDeleteButton}
                  onClickSave={handleSaveQuestion}
                  onClickEdit={handleClickEditQuestion}
                  onClickDelete={handleDeleteQuestion}
                  onClickFinish={props.onClickFinish}
                  onClickView={handleClickViewQuestion}
                />
                {/* ========== Enunciado ========== */}
                <p
                  className='section-text'
                >
                  {t('editor.resources.exercise.content')}
                </p>
                <TinyEditorComponent
                  editState={props.editState}
                  data={question.question.content}
                  onChange={handleChangeContentQuestion}
                />
                {['multiple-choice-unique-answer'].includes(question?.question?.question_category?.name) && props.isCharacterizationSurvey && (
                  <div style={{ display: 'flex', gap: '12px', marginTop: '10px', alignItems: 'center' }}>
                    <CheckBoxComponent disabled={!props.editState} checked={!!question?.question?.config?.show_as_select} onClick={handleChangeShowAsSelect} />
                    <LabelComponent>Mostrar como selector</LabelComponent>
                  </div>
                )}
                {question?.question?.question_category?.name === 'container' ? (
                  <>
                    <p className='section-text'>
                      {t('editor.resources.exercise.category')}
                    </p>
                    <input
                      type="text"
                      placeholder=''
                      className='form-control'
                      onChange={(e) => handleChangeCategory(e.target.value) }
                      defaultValue={question?.question?.config?.category}
                    />
                  </>
                ): null}
                {/* ========= Respuestas =========== */}
                {   question.question.question_category.name !== 'open-answer' &&
                    question.question.question_category.name !== 'container' &&
                    question.question.question_category.name !== 'select-range' ?
                    <>
                        <p className='section-text-responses' >
                          {t('editor.resources.exercise.response')}
                        </p>
                        {question.question.answers && question.question.answers.length ?
                          resetAnswers ? null :
                          <DragDropContext onDragEnd={handleReorderAnswers} >
                            <Droppable
                              droppableId={question.question._id}
                              // droppableId='drag-answers-question'
                            >
                              {(provided, snapshot) => (
                                <div
                                  {...provided.droppableProps}
                                  ref={provided.innerRef}
                                >
                                  {question.question.answers.map((itemAnswer, idxAnswer) => (
                                    <Draggable
                                      draggableId={itemAnswer._id}
                                      index={idxAnswer}
                                      key={itemAnswer._id}
                                    >
                                      {(provided2, snapshot2) => (
                                        <div
                                          ref={provided2.innerRef}
                                          {...provided2.draggableProps}
                                          id={itemAnswer._id}
                                        >
                                          <OutlineContainerDrag
                                            provided={provided2}
                                            title={`${t('editor.resources.exercise.answer')} ${idxAnswer+1} ${t('editor.resources.exercise.of_this_question')}`}
                                            className='container-answer'
                                          >
                                            <HeaderEditorPanelExercise
                                              editState={props.editState}
                                              onClickDelete={()=>handleClickDeleteAnswer(idxAnswer)}
                                              hideSaveButton
                                              hideAddButton
                                              hideEditButton
                                              hideViewButton
                                              hideFinishButton
                                              style={{marginBottom: '-10px'}}
                                            />
                                              <div
                                                className={`content-tiny_editor ${props.hideFeedbackField ? 'column-100' : ''} ${question.question.question_category.name}`}
                                              >
                                                <div>
                                                  <p className='section-text'>
                                                    {t('editor.resources.exercise.question_item')}
                                                  </p>
                                                  <TinyEditorComponent
                                                    editState={props.editState}
                                                    data={itemAnswer.content}
                                                    onChange={(content) => handleEditorChange('content', itemAnswer._id, content)}
                                                  />
                                                </div>
                                                {/* {!props.hideFeedbackField ?
                                                  <div>
                                                    <p className='section-text'>
                                                      {t('editor.resources.exercise.feedback')}
                                                    </p>
                                                    <TinyEditorComponent
                                                      editState={props.editState}
                                                      data={itemAnswer.feedback as string}
                                                      minHeight={56}
                                                      onChange={(content, editor) => handleEditorChange('feedback', itemAnswer._id, content, editor)}
                                                    />
                                                  </div>
                                                :null} */}
                                              </div>
                                              {/* Acciones extra */}
                                              <>
                                                  <div className="container-options-answer">
                                                    {/* {!props.hideCorrectCheck ?
                                                      <div className="form-check correct-check-field">
                                                          <CheckBoxComponent
                                                            disabled={!props.editState}
                                                            checked={itemAnswer.is_correct}
                                                            onClick={() => handleClickCorrect(itemAnswer._id)}
                                                          />
                                                          <p>
                                                            {t('editor.resources.exercise.correct')}
                                                          </p>
                                                      </div>
                                                    :null} */}
                                                    {props.showRequiredCheck ?
                                                      <div className="form-check correct-check-field">
                                                          <CheckBoxComponent
                                                            disabled={!props.editState}
                                                            checked={itemAnswer.config?.is_required ? true : false}
                                                            onClick={() => handleClickRequired(itemAnswer._id)}
                                                          />
                                                          <p>
                                                            {t('editor.resources.exercise.is_required')}
                                                          </p>
                                                      </div>
                                                    :null}
                                                    {/* {!props.hideValueField ?
                                                      <div className="container-value-answer">
                                                        <p>
                                                          {t('editor.resources.exercise.value')}
                                                        </p>
                                                        <div className="input-group input-value">
                                                            <input disabled={!props.editState} type="number" onChange={(e)=>handleChangeValue(e, idxAnswer)} className="form-control" value={itemAnswer.value} aria-describedby="basic-addon1" />
                                                        </div>
                                                      </div>
                                                    :null} */}
                                                  </div>
                                              </>
                                              {props.showValidationSettings ?
                                                <div className="container-validation-settings">
                                                  <div>
                                                    <LabelComponent>
                                                      Tipo de evento
                                                    </LabelComponent>
                                                    <Form>
                                                        <Form.Group>
                                                            <Form.Control
                                                              disabled={!props.editState}
                                                              onChange={(e) => handleChangeValidationSetting(e, itemAnswer._id, 'event_type')}
                                                              value={itemAnswer.config?.event_type}
                                                              as='select'
                                                              custom
                                                            >
                                                            <option>-- Elige una opción --</option>
                                                            {props.eventTypes?.length ?
                                                              props.eventTypes.map((itemEvent) => (
                                                                <option
                                                                  value={itemEvent._id}
                                                                >
                                                                  {itemEvent.description}
                                                                </option>
                                                              ))
                                                            :null}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Form>
                                                  </div>
                                                  {handleShowTerms(itemAnswer.config?.event_type) ?
                                                    <div>
                                                      <LabelComponent>
                                                        Términos y condiciones
                                                      </LabelComponent>
                                                      <Form>
                                                          <Form.Group>
                                                              <Form.Control
                                                                disabled={!props.editState}
                                                                onChange={(e) => handleChangeValidationSetting(e, itemAnswer._id, 'terms_and_conditions')}
                                                                value={itemAnswer.config?.terms_and_conditions}
                                                                as='select'
                                                                custom
                                                              >
                                                              <option>-- Elige una opción --</option>
                                                              {props.termsAndConditions?.length ?
                                                                props.termsAndConditions.map((itemTerms) => (
                                                                  <option
                                                                    value={itemTerms._id}
                                                                  >
                                                                    {itemTerms.description}
                                                                  </option>
                                                                ))
                                                              :null}
                                                              </Form.Control>
                                                          </Form.Group>
                                                      </Form>
                                                    </div>
                                                  :null}
                                                </div>
                                              :null}
                                          </OutlineContainerDrag>
                                        </div>
                                      )}
                                    </Draggable>
                                  ))}
                                  {provided.placeholder}
                                </div>
                              )}
                            </Droppable>
                          </DragDropContext>
                        :null}
                        { props.editState && (
                            <NewQuestionButton
                              className='add-new-answer'
                              onClick={handleAddNewAnswer}
                            >
                              {t('editor.resources.exercise.add_other_option')}
                            </NewQuestionButton>
                        )}
                    </>
                :question.question.question_category.name === 'select-range' ?
                  <LabelComponent
                    style={{ marginTop: '15px' }}
                  >
                    Definir rango
                    <div className="container-define-range">
                      <span>De 1 a</span>
                      <InputComponent
                        type='number'
                        className='input-range'
                        value={question.question.config.range ? question.question.config.range.toString(): '0'}
                        onChange={handleChangeRange}
                      />
                    </div>
                  </LabelComponent>
                :null}
                {/* { question.question.question_category.name === 'open-answer' ?
                  <ConfigQuestionPanel
                    config={question.question.config}
                    possibleConfig={question.question.question_category.config}
                    onChangeConfig={handleChangeConfig}
                    disabled={!props.editState}
                  />
                : null} */}
                {props.children}
            </div>
        :(null)
    );
};

export default EditorPanelExerciseEditorLayout;
